require.register("thesaurus/controllers/indexCtrl", function(exports, require, module){
  $0
  
});

